import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'
import Collapse, { Panel } from 'rc-collapse'
import NoData from './no-data'
import EvIframe from '../../../../../containers/shared/evergent-iframe'
import {
  CreditCardPanelHeader,
  CreditCardPanelBody
} from './credit-card-panel-components'
import CREDIT_CARD_FRAGMENT from '../../../../../../graphql/fragments/credit-cards.gql'

import styles from '../payment.css'

const MobileTable = ({
  tableData,
  tableColumns,
  iframeEditUrl,
  iframeAddUrl,
  iframeIsOpen,
  isAddNewCreditCard,
  activeEditionPanel,
  onIframeLoad,
  handleIframeCancelClick,
  handleMobilePanelChange
}) => {
  // Keep accordion state inside the mobile table so it resets when switching layouts
  const [activePanel, setActivePanel] = useState(null)

  useEffect(() => {
    if (isAddNewCreditCard) {
      setActivePanel(null)
    }
  }, [isAddNewCreditCard])

  const handleActivePanelChange = (creditCardID) => {
    setActivePanel(creditCardID)
    handleMobilePanelChange(creditCardID)
  }

  if (tableData.length === 0) {
    return <NoData />
  }

  return (
    <>
      {isAddNewCreditCard && (
        <div className={styles.creditCardCollapseItem}>
          <EvIframe
            className={styles.addCreditCardIframe}
            src={iframeAddUrl}
            onLoad={onIframeLoad}
            onCancel={handleIframeCancelClick}
          />
        </div>
      )}

      <Collapse
        accordion
        activeKey={activePanel}
        onChange={handleActivePanelChange}
      >
        {tableData.map((props, index) => (
          <Panel
            // eslint-disable-next-line react/prop-types
            key={props.id}
            showArrow={false}
            className={classNames(
              styles.creditCardCollapseItem,
              // eslint-disable-next-line react/prop-types
              { [styles.itemActive]: activePanel === props.id }
            )}
            header={(
              <CreditCardPanelHeader
                // eslint-disable-next-line react/prop-types
                creditCardName={props.name}
                // eslint-disable-next-line react/prop-types
                isDefault={props.useForSubscriptions || props.useForPurchases}
                // eslint-disable-next-line react/prop-types
                isOpen={activePanel === props.id}
              />
            )}
          >
            <CreditCardPanelBody
              activePanel={activePanel}
              creditCardProps={props}
              columns={tableColumns}
              index={index}
              iframeEditUrl={iframeEditUrl}
              iframeIsOpen={iframeIsOpen}
              activeEditionPanel={activeEditionPanel}
              onIframeLoad={onIframeLoad}
              handleIframeCancelClick={handleIframeCancelClick}
            />
          </Panel>
        ))}
      </Collapse>
    </>
  )
}

MobileTable.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.oneOfType([
      propType(CREDIT_CARD_FRAGMENT),
      PropTypes.shape({}) // for td iframe placeholder
    ])
  ).isRequired,
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      Cell: PropTypes.func.isRequired,
      Header: PropTypes.string.isRequired,
      accessor: PropTypes.string,
      id: PropTypes.string.isRequired,
      minWidth: PropTypes.number
    })
  ).isRequired,
  iframeAddUrl: PropTypes.string,
  iframeEditUrl: PropTypes.string,
  iframeIsOpen: PropTypes.bool.isRequired,
  isAddNewCreditCard: PropTypes.bool,
  activeEditionPanel: PropTypes.string,
  onIframeLoad: PropTypes.func.isRequired,
  handleIframeCancelClick: PropTypes.func.isRequired,
  handleMobilePanelChange: PropTypes.func.isRequired
}

MobileTable.defaultProps = {
  iframeEditUrl: null,
  iframeAddUrl: null,
  activeEditionPanel: null,
  isAddNewCreditCard: false
}

export default MobileTable
